import React, { useEffect } from 'react';
import ArrowRight from 'components/shared/arrow-right';
import KeuneIcon from 'components/shared/keune-icon-white';
import Icon from 'components/shared/marker';
import styles from './salonMatch.module.scss';
import useSalonMatchClickTracking from '../../../../hooks/tracking/useSalonMatchClickTracking';

const SalonMatch = ({
  index,
  salon,
  formattedDistance,
  hovered,
  setHovered,
  setActive,
  setShowSalon,
  setSalonFocus,
}) => {
  useEffect(() => {
    setActive(hovered);
  }, [hovered]);

  return (
    <div
      className={styles.matchContainer}
      onClick={() => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useSalonMatchClickTracking();
        setSalonFocus(salon);
        setShowSalon(true);
      }}
      onMouseEnter={() => setHovered(index)}
      onMouseLeave={() => setHovered(null)}
      aria-hidden="true"
    >
      <div className={styles.markerContainer}>
        <Icon />
        <p className={styles.distance}>{formattedDistance} KM</p>
      </div>
      <div className={styles.matchInformation}>
        {salon?.salonLoyalty && (
          <span className={styles.keuneYou}>
            {' '}
            <KeuneIcon className={styles.logo} /> Keune Ambassador Salon
          </span>
        )}
        {!salon?.salonLoyalty && salon.client100 && (
          <span className={styles.keuneYou}>
            {' '}
            <KeuneIcon className={styles.logo} /> Keune Salon
          </span>
        )}
        <h2 className={styles.salonName}>
          {index + 1}. {salon?.salonName}
        </h2>
        <p className={styles.address}>
          {salon?.AddressLine2}, {salon?.ZipCode || salon?.zipCode}
        </p>
        <p className={styles.address}>
          {salon?.city}, {salon?.country}
        </p>
      </div>
      <div className={styles.arrowContainer}>
        <ArrowRight />
      </div>
    </div>
  );
};

export default SalonMatch;
